import { useMemo } from 'react';
import { useFarm } from '../context/AccountContext';
import { resolveSurveyCountryCodeFromFarm } from '../model/surveys/country/SurveyCountryStrategy';

export function useSurveyCountryCode(): string | null {
  const farm = useFarm();
  return useMemo(() => resolveSurveyCountryCodeFromFarm(farm), [farm]);
}
